import React from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import Checkbox from 'components/shared/inputs/checkbox';
import type IMultiSelectOption from '../shared/types/multiSelectOption';
import { useMultiSelect } from './MultiSelectProvider';

/* #region  styles */
const Option = styled.li<{ $isSelected: boolean }>`
    display: flex;
    padding: 12px 16px;
    align-items: center;
    cursor: pointer;

    & > :first-child {
        margin-right: ${Spacing8};
    }
`;
/* #endregion */

export default function MultiSelectOption({ option }: { option: IMultiSelectOption }) {
    const { isSelected, toggleOption, name } = useMultiSelect();

    const selected = isSelected(option);

    return (
        <Option onClick={() => toggleOption(option)} $isSelected={selected}>
            <Checkbox name={name} value={option.value} readOnly checked={selected} />
            {option.label}
        </Option>
    );
}
